export default "__VITE_ASSET__6ca298b8__"